import { useDispatch } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';

import { providerActions } from '../../store';

import type { AppDispatch } from '../../store';

// Wraps the invite-to-platform thunk plus a provider re-fetch so the page component stays free of
// direct `useDispatch` use. The re-fetch runs on every outcome so the displayed status reflects the
// server after a success and after an unknown network result; the slice toasts the generic error on
// failure.
export const useInviteProviderToPlatform = (providerId: number | string | undefined) => {
  const dispatch = useDispatch<AppDispatch>();
  const { getAccessTokenSilently } = useAuth0();

  return async () => {
    // Invite and re-fetch both require a concrete provider id in the URL; callers may
    // pass `provider?.id` before the detail has loaded.
    if (providerId === undefined) {
      return;
    }

    const result = await dispatch(
      providerActions.inviteProviderToPlatform({ providerId, getAccessTokenSilently }),
    );
    await dispatch(providerActions.getProviderById({ getAccessTokenSilently, providerId }));
    return result;
  };
};
